import { Sparkles, ShieldCheck } from "lucide-react";
import CallbackForm from "./CallbackForm";

const HERO_IMG =
  "https://images.pexels.com/photos/356036/pexels-photo-356036.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

export default function HeroLeadMontaz() {
  return (
    <section
      id="top"
      className="relative pt-24 lg:pt-32 pb-12 lg:pb-20 overflow-hidden hero-grid-bg"
      data-testid="hero-section-montaz"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-14 items-center">
          {/* Left: copy + form */}
          <div className="lg:col-span-7 heliora-fade-up">
            <div className="inline-flex items-center gap-2 rounded-full bg-brand-surface text-brand-blue px-3 py-1.5 text-xs font-bold uppercase tracking-wider">
              <Sparkles className="h-3.5 w-3.5" />
              Bezpłatna konsultacja · 5–10 minut
            </div>
            <h1 className="mt-4 font-heading font-extrabold tracking-tight text-brand-ink text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.05]">
              Montaż{" "}
              <span className="relative inline-block">
                <span className="relative z-10">fotowoltaiki</span>
                <span className="absolute left-0 right-0 bottom-1 h-3 bg-brand-yellow/70 -z-0 rounded-sm"></span>
              </span>{" "}
              bez chaosu i dziesiątek telefonów.
            </h1>
            <p className="mt-5 text-base sm:text-lg text-brand-muted leading-relaxed max-w-xl">
              Zostaw numer — oddzwonimy w ciągu <strong className="text-brand-ink">5–10 minut</strong>{" "}
              i pomożemy Ci przejść przez cały proces.
            </p>

            {/* Lead form */}
            <div id="lead-form" className="mt-7 max-w-xl scroll-mt-28" data-testid="hero-lead-form-montaz">
              <CallbackForm
                source="Hero"
                ctaLabel="Zostaw numer"
                helperText="Bez spamu · Bez zobowiązań · Bez nacisku"
                inputId="hero-phone"
                testIdPrefix="hero-callback"
              />
            </div>
          </div>

          {/* Right: image with overlay card */}
          <div className="lg:col-span-5 relative heliora-fade-up" style={{ animationDelay: "0.1s" }}>
            <div className="absolute -inset-10 sun-glow pointer-events-none" aria-hidden="true" />
            <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-1 ring-black/5">
              <img
                src={HERO_IMG}
                alt="Profesjonalny montaż paneli fotowoltaicznych"
                className="w-full h-[320px] sm:h-[440px] lg:h-[500px] object-cover"
                loading="eager"
              />
              {/* Overlay card */}
              <div
                className="absolute bottom-4 left-4 right-4 sm:right-auto sm:max-w-[260px] bg-white/95 backdrop-blur-md rounded-2xl p-4 shadow-xl border border-white"
                data-testid="hero-overlay-card-montaz"
              >
                <p className="font-heading font-bold text-brand-ink text-lg leading-snug">
                  Spokojny proces bez chaosu
                </p>
                <div className="mt-2 flex items-center gap-1.5 text-xs text-brand-muted">
                  <ShieldCheck className="h-3.5 w-3.5" />
                  Sprawdzony instalator
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
